import { render } from "./deleted.vue?vue&type=template&id=e44eb120&scoped=true"
import script from "./deleted.vue?vue&type=script&lang=js"
export * from "./deleted.vue?vue&type=script&lang=js"

import "./deleted.vue?vue&type=style&index=0&id=e44eb120&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44eb120"]])

export default __exports__